import { ApiResponse, AxiosErrorCustom, axiosInstance } from '@/lib/axios';
import { z } from 'zod';
import { TTeam } from '../types/team.type';
import { TypedMutationConfig } from '@/lib/react-query';
import { useMutation } from '@tanstack/react-query';

/**
 *
 */
export const AddAgentToTeamSchema = z.object({
  teamId: z.string().min(1, { message: 'Team ID is required' }),
  userIds: z.array(z.string()).min(1, { message: 'User IDs are required' }),
});
export type TAddAgentToTeamValidation = z.infer<typeof AddAgentToTeamSchema>;
export type TAddAgentToTeamPayload = TAddAgentToTeamValidation;
export type TAddAgentToTeamResponse = ApiResponse<TTeam>;

export const addAgentToTeam = async (payload: TAddAgentToTeamPayload): Promise<TAddAgentToTeamResponse> => {
  const url = `/team/add-user/${payload.teamId}`;

  const payloadData = {
    userIds: payload.userIds,
  };

  return axiosInstance.post(url, payloadData);
};

/**
 *
 */
type TUseAddAgentToTeamOptions = {
  mutationConfig?: TypedMutationConfig<typeof addAgentToTeam, AxiosErrorCustom>;
};

export const useAddAgentToTeam = ({ mutationConfig }: TUseAddAgentToTeamOptions) => {
  const { ...restConfig } = mutationConfig || {};

  return useMutation<TAddAgentToTeamResponse, AxiosErrorCustom, TAddAgentToTeamPayload>({
    mutationFn: addAgentToTeam,
    ...restConfig,
  });
};
